import { components, detachable, setOverflow } from '@/utils'

import render from './render'

export default {
  name: components.overlay,

  mixins: [ detachable ],

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    value() {
      setOverflow(this.value)
    }
  },

  mounted() {
    if (document.body) {
      document.body.addEventListener('click', this.toggle)
    }
  },

  beforeDestroy() {
    if (document.body) {
      document.body.removeEventListener('click', this.toggle)
    }
  },

  methods: {
    toggle() {
      this.$emit('input', !this.value)
    }
  },

  render
}
